import { cleanCell, isPrivateColumn, SAFE_HEADERS, sourceLeaderRole } from './rosterImportFormat';

export const FIELD_LABELS = {
  ignore:'Använd inte', full_name:'Fullständigt namn', first_name:'Förnamn', last_name:'Efternamn',
  gender:'Kön', birthdate:'Födelsedatum', birth_year:'Födelseår', jersey_number:'Tröjnummer', position:'Position',
  player_email:'Personens egen e-post', player_phone:'Telefon', notes:'Anteckningar', role:'Ledarroll', member_type:'Medlemstyp',
  ...Object.fromEntries(['parent','parent2','parent3'].flatMap((p,i)=>[
    [p+'_name',`Målsman ${i+1} – namn`],[p+'_first_name',`Målsman ${i+1} – förnamn`],
    [p+'_last_name',`Målsman ${i+1} – efternamn`],[p+'_email',`Målsman ${i+1} – e-post`],
    [p+'_phone',`Målsman ${i+1} – telefon`],[p+'_relation',`Målsman ${i+1} – relation`],
  ])),
};
const SV_FIELDS = {role:'_trainnova_role',gender:'Kön',first_name:'Förnamn',last_name:'Efternamn',birthdate:'Födelsedatum',
  player_email:'E-post',player_phone:'Mobil',
  ...Object.fromEntries(['parent','parent2','parent3'].flatMap((p,i)=>[
    [p+'_name',`Målsman ${i+1} - Namn`],[p+'_email',`Målsman ${i+1} - E-post 1`],[p+'_phone',`Målsman ${i+1} - Mobil`],
  ]))};
export function editableValues(row, preset, group, selectedTeam) {
  if (!row) return {};
  if (preset) return {...Object.fromEntries(Object.entries(SV_FIELDS).map(([key,source])=>[key,cleanCell(row[source])])),
    player_email:cleanCell(row['E-post'] || row['E-post 1']),player_phone:cleanCell(row.Mobil || row.Telefon),
    ...(group==='leaders'?{role:sourceLeaderRole(row,selectedTeam)}:{})};
  const values = {...row};
  for (const p of ['parent','parent2']) values[p+'_name'] = row[p+'_name'] || [row[p+'_first_name'],row[p+'_last_name']].filter(Boolean).join(' ');
  if (group === 'leaders') {
    values.player_email = row.player_email || row.parent_email || '';
    if (!values.role && ['head_coach','assistant_coach','coach','team_manager'].includes(row.member_type)) values.role=row.member_type;
  }
  return values;
}
export function correctionPatch(patch, preset, group) {
  const allowed = [...(group==='players'?['gender']:[]),'first_name','last_name','birthdate','player_email','player_phone',
    ...(!preset ? ['birth_year'] : []),...(group==='leaders'?['role']:[]),
    ...(group==='players' ? ['parent','parent2','parent3'].flatMap(p=>[p+'_name',p+'_email',p+'_phone']) : [])];
  const safe = Object.fromEntries(Object.entries(patch).filter(([key])=>allowed.includes(key)));
  if (preset) {
    const raw = Object.fromEntries(Object.entries(safe).map(([key,v])=>[SV_FIELDS[key],v]));
    if ('player_email' in safe) raw['E-post 1'] = safe.player_email;
    if ('player_phone' in safe) raw.Telefon = safe.player_phone;
    if ('birthdate' in safe) {raw._trainnova_birth_source='';raw._trainnova_birth_issue=false;}
    return raw;
  }
  for (const p of ['parent','parent2']) if (p+'_name' in safe) { safe[p+'_first_name']=''; safe[p+'_last_name']=''; }
  if (group==='leaders' && 'player_email' in safe) safe.parent_email='';
  return safe;
}
export function applyRowEdits(rows, edits) {
  return rows.map((row,index)=>({...row,...(edits[index] || {})}));
}
export function columnOverview(headers, map, preset) {
  return headers.map((header,index)=>{
    const label=cleanCell(header)||`Kolumn ${index+1}`;
    const status=isPrivateColumn(header)?'private':(preset ? SAFE_HEADERS.has(cleanCell(header)) : map[index] && map[index]!=='ignore')?'mapped':'ignored';
    return {index,label,status,target:preset ? label : FIELD_LABELS[map[index]] || map[index] || 'Använd inte'};
  });
}
export function reviewSelection(entries, filter, page, size=25) {
  const counts={all:entries.length,needs_info:0,ready:0,duplicate:0};
  for(const row of entries) if(row.status in counts) counts[row.status]++;
  const rows=entries.filter(row=>filter==='all'||row.status===filter).sort((a,b)=>({needs_info:0,ready:1,duplicate:2}[a.status]??3)-({needs_info:0,ready:1,duplicate:2}[b.status]??3));
  const pages=Math.max(1,Math.ceil(rows.length/size)); const current=Math.max(1,Math.min(page,pages));
  return {counts,total:rows.length,page:current,pages,rows:rows.slice((current-1)*size,current*size)};
}
const WARNING_LABELS = {missing_email:'E-post saknas',invalid_email:'Ogiltig e-post',missing_name:'Namn behöver kompletteras',duplicate:'Dubblett i underlaget',parent_invalid_email:'Ogiltig målsmansadress',player_invalid_email:'Ogiltig egen e-post'};
export function reviewCsv(entries) {
  const cell=value=>{
    let text=String(value??'');
    // Do not let names or notes become spreadsheet formulas when opened.
    if (/^[\s\uFEFF]*[=+@-]/.test(text)) text="'"+text;
    return '"'+text.replace(/"/g,'""')+'"';
  };
  const rows=[['Post i underlaget','Namn','Grupp','Trainnova importstatus','Trainnova granskningsorsak'],
    ...entries.filter(row=>row.status!=='ready').map(row=>[
      Number.isInteger(row.source_row_index)?row.source_row_index+1:'',row.name||[row.first_name,row.last_name].filter(Boolean).join(' '),
      row.group==='leaders'?'Ledare':'Spelare',row.status==='needs_info'?'Behöver granskas':'Överhoppad',
      [row.match_reason,...(row.warnings||[]).map(w=>WARNING_LABELS[w]||w)].filter(Boolean).join(' · '),
    ])];
  return '\uFEFF'+rows.map(row=>row.map(cell).join(';')).join('\r\n');
}
